var _style, _path, _defs, _g, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _rect3, _rect4, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20, _polygon, _path21, _polygon2, _g2, _polygon3, _path22, _g3, _g4, _g5, _polygon4, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatesIllustrationAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307 325.5",
    style: {
      enableBackground: "new 0 0 307 325.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{clip-path:url(#SVGID_00000131353763416910774470000001104527567299633063_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{font-family:'ArialMT';}\r\n\t.st4{font-size:48.9279px;}\r\n\t.st5{fill:#8282BC;}\r\n\t.st6{fill:url(#SVGID_00000051358409238258705970000001778959193604121512_);}\r\n\t.st7{fill:url(#SVGID_00000145751233834341910450000004444844013357615754_);}\r\n\t.st8{fill:#B3B2D8;}\r\n\t.st9{fill:#EDEDED;}\r\n\t.st10{fill:#BABABA;}\r\n\t.st11{fill:url(#SVGID_00000005965060153276856620000009764805931853814432_);}\r\n\t.st12{fill:#8C8C8C;}\r\n\t.st13{fill:#FF6584;}\r\n\t.st14{fill:#F2F2F2;}\r\n\t.st15{fill:#E0E0E0;}\r\n\t.st16{fill:url(#SVGID_00000109013043096038900260000002421490236389060995_);}\r\n\t.st17{fill:url(#SVGID_00000008144358774551254420000017632297968927967669_);}\r\n\t.st18{fill:#029CE0;}\r\n\t.st19{fill:url(#SVGID_00000114782421736979416690000001622905755601836470_);}\r\n\t.st20{fill:url(#SVGID_00000106109783774100231250000009565489123765943723_);}\r\n\t.st21{fill:url(#SVGID_00000038401624937934971160000005617896446826882733_);}\r\n\t.st22{fill:#F9F9F9;}\r\n\t.st23{fill:url(#SVGID_00000118375549490102011520000004750831834215813551_);}\r\n\t.st24{fill:url(#SVGID_00000126322961421487083260000003224304525043931020_);}\r\n\t.st25{opacity:0.31;fill:#C8D3D7;enable-background:new    ;}\r\n\t.st26{opacity:0.4;fill:#72A7D3;enable-background:new    ;}\r\n\t.st27{opacity:0.15;}\r\n\t.st28{opacity:0.11;fill:#C8D3D7;enable-background:new    ;}\r\n\t.st29{opacity:6.000000e-02;fill:#C8D3D7;enable-background:new    ;}\r\n\t.st30{opacity:0.11;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st31{opacity:0.27;fill:#FFFFFF;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.0076,
    y1: 632.2646,
    x2: 312.2025,
    y2: 725.6875,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F5F9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1547,
    style: {
      stopColor: "#E7EEF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    style: {
      stopColor: "#D2DDF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7284,
    style: {
      stopColor: "#C5D3EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C1D0EA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.1,61.7c19.4-3.7,39.5-0.5,56.7,9.1c10.6,5.8,19.6,14.1,26.2,24.2c23.6,36.3,42.3,172.6-86.4,198.4 c-139,27.8-179.3-98.8-185-113.1S-31.8,87.9,38.8,56.5C107.9,25.7,56.1,90.5,206.1,61.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000079484164779219918880000013859996910921590176_",
    cx: 167.6,
    cy: 152.2,
    r: 148
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027581932747424357500000005315599021496386699_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000079484164779219918880000013859996910921590176_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027581932747424357500000005315599021496386699_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.1,165.5l98.4-0.4c4.5,0,8.1,3.6,8.2,8.1l0,0l0.3,95.7c0,4.5-3.6,8.1-8.1,8.2l0,0l-98.4,0.4 c-4.5,0-8.1-3.6-8.2-8.1l0,0l-0.3-95.7C108.9,169.2,112.6,165.5,117.1,165.5L117.1,165.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "118.5,173 128.5,214.6 120.7,226.1 94.5,207.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 170.3,
    transform: "matrix(1 -3.648928e-03 3.648928e-03 1 -0.8606 0.609)",
    className: "st2",
    width: 87,
    height: 131.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.8,172.7c0.6,0.4,1.2,0.8,1.9,1.1c8.8,4,17.4,4.9,33.7,4.8c19.8-0.1,33.8-1.8,43.1-8.5l-81.8,0.3 L128.8,172.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.7,241l-76.4,0.3c-10.4,0-10,9.8-10,21.9l0,0c0,12.1-0.3,21.8,10.1,21.8l76.4-0.3 c10.4,0,10-9.8,10-21.9l0,0C214.8,250.8,215.1,241,204.7,241z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 281.2,
    transform: "matrix(1 -3.648753e-03 3.648753e-03 1 -1.1017 0.5104)",
    className: "st2",
    width: 32.3,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.3,
    y: 323.2,
    transform: "matrix(1 -3.651895e-03 3.651895e-03 1 -1.185 0.5113)",
    className: "st2",
    width: 32.3,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.7,373.3l-32.3,0.1l-2.5-45.4c0-0.9,0.6-1.6,1.5-1.7h0.1l33.5-0.1c0.9,0,1.6,0.7,1.6,1.6 c0,0,0,0,0,0.1L155.7,373.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.8,373.5c-0.8,0-1.4-0.5-1.6-1.3c-1-4.4-3.2-18.9,9.2-16.8c14.6,2.4,26.6,18,26.6,18L115.8,373.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 281,
    transform: "matrix(1 -3.647706e-03 3.647706e-03 1 -1.1003 0.7101)",
    className: "st2",
    width: 32.3,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.1,
    y: 323,
    transform: "matrix(1 -3.651720e-03 3.651720e-03 1 -1.1839 0.7114)",
    className: "st2",
    width: 32.3,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.2,373.2l32.3-0.1l2.2-45.4c0-0.9-0.6-1.6-1.5-1.7h-0.1l-33.5,0.1c-0.9,0-1.6,0.7-1.6,1.6 c0,0,0,0,0,0.1L178.2,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M218.2,373.1c0.8,0,1.4-0.5,1.6-1.3c0.9-4.4,3-18.9-9.3-16.8c-14.6,2.5-26.4,18.2-26.4,18.2 L218.2,373.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.8,170.1c2.1-0.4,4.6,1.9,5,3.5l-4,42.6l-0.8-0.1L209.8,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.1,257.6l-25.5,19.1l8.5-64.4c0.3-0.8,1.2-1.2,2.1-0.9c0,0,0,0,0.1,0l29.6,13.3L104.1,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91,212.4c0.1-2.1,1.8-3.9,3.5-5.2l24.3,17.4L91,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.8,170.5c-2.1-0.4-4.6,1.9-5,3.5l4,42.6l0.8-0.1L122.8,170.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143,199.6l46.6-0.2c2.8,0,5.1,2.3,5.1,5.1l0.1,22.9c0,2.8-2.3,5.1-5.1,5.1l-46.6,0.2 c-2.8,0-5.1-2.3-5.1-5.1l-0.1-22.9C137.9,201.9,140.2,199.6,143,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.1,201.1l44.6-0.2c2.5,0,4.4,2,4.5,4.4l0.1,21.3c0,2.5-2,4.4-4.4,4.5l-44.6,0.2 c-2.5,0-4.4-2-4.5-4.4l-0.1-21.3C139.6,203.1,141.6,201.1,144.1,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.9,215.4c0,2.7-2.2,4.9-4.9,5s-4.9-2.2-5-4.9c0-2.7,2.2-4.9,4.9-5 C154.7,210.5,156.9,212.7,156.9,215.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.6,204.9l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.1,205.1,164.4,204.9,164.6,204.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.6,209.9l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,210.1,164.4,209.9,164.6,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.7,214.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,215.1,164.4,214.9,164.7,214.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.7,219.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,220.1,164.4,219.8,164.7,219.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.7,224.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,225.1,164.4,224.8,164.7,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.7,214.1L138,214v4.2l-14.3,0.1c-1.1-0.1-2-1-1.9-2.1l0,0C121.8,215.1,122.6,214.1,123.7,214.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208.9,218.1l-14.1,0.1V214l14.1-0.1c1.1,0.1,1.9,1,1.9,2.1l0,0C210.8,217.1,210,218,208.9,218.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 166.1,
    cy: 116.3,
    r: 58.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -3.650499e-03 3.650499e-03 1 -0.4384 0.6071)",
    className: "st2",
    cx: 166.1,
    cy: 120.4,
    rx: 56.2,
    ry: 45.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -3.648055e-03 3.648055e-03 1 -0.4381 0.6067)",
    className: "st2",
    cx: 166.1,
    cy: 120.4,
    rx: 54.7,
    ry: 44.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.8,95.7c-1.4-4.9-7.3-5.5-13.8-0.1c-6.5,5.4-9.3,10.8-6.5,13.7c3.8,3.9,7.5,4.1,13.5-1.9 C142.7,103.5,147.3,100.8,145.8,95.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.2,258.6H261l-15.8-52.8c-0.3-0.8-1.2-1.2-2.1-0.9c0,0,0,0-0.1,0l-31.7,14L236.2,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.3,205.7c-0.1-2.1-1.8-3.9-3.5-5.2l-24.3,17.4L241.3,205.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "214.8,173.6 210.7,214.4 211.5,219.3 237.7,200.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 220.8,
    transform: "matrix(0.9969 -7.891816e-02 7.891816e-02 0.9969 -20.1466 14.4334)",
    className: "st2",
    width: 134.9,
    height: 82.6
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.997 -7.788717e-02 7.788717e-02 0.997 131.5795 282.8287)",
    className: "st2 st3 st4"
  }, "404"), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.2,294.2l-14.6-12.7l12-16.6l1-1.3l3.8-3.4l2.2-1.7c2-0.9,4.2-1.3,6.4-1.2h8.3 c2.5,0,4.6,1.8,4.9,4.3c0.2,2.6-1.7,4.9-4.3,5.2c-0.2,0-0.3,0-0.5,0h-1.6l7,6.1c4.3,3.8,4.8,10.3,1,14.7l-4.5,5.2 C113,299,103.5,299.7,97.2,294.2L97.2,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.6,281.5c-2-0.7-3.3-2.8-4-4.8l22.2-17.6L82.6,281.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "237.8,259.6 261,262 261,258.6 241,258.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.9,281.2l2-19.2l-22.5-2.4l0,0h-0.6l0,0l-14.6,7.9c-0.9,0.5-1.7,1.3-2.3,2.1c-0.8,1.3-1,2,0.2,3.7 c0.7,1.3,2.3,1.9,3.8,1.4c0.7-0.2,1.4-0.6,1.9-1.1l0.5-0.5l-1,9.3c-0.6,5.7,3.5,10.8,9.2,11.4l6.8,0.7 C250.6,295.5,258,289.5,258.9,281.2L258.9,281.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "181.2,112.4 179.8,112.3 180.8,113.3 180.1,116.2 181.9,113.8 183.4,114 182.4,112.9  183.2,110  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.3,128.9c-0.1-0.7,0.3-1.3,1-1.5s1.3,0.3,1.5,1c0.1,0.7-0.3,1.3-1,1.5l0,0 C202.1,130.1,201.4,129.6,201.3,128.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.6,149.7c0.2,0,0.4,0.1,0.4,0.3c0,0.1,0,0.2-0.1,0.3l-2.9,4.2c-0.1,0.2-0.3,0.2-0.5,0.1 c-0.2-0.1-0.2-0.3-0.1-0.5l2.9-4.2C155.4,149.8,155.5,149.8,155.6,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152,150.4c0.1,0,0.2,0,0.3,0.1l4.2,2.9c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1l0,0 l-4.2-2.9c-0.2-0.1-0.2-0.3-0.1-0.5C151.8,150.5,151.9,150.4,152,150.4L152,150.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "194.3,143 192.1,142.8 193.7,144.3 192.6,148.5 195.2,145.1 197.3,145.3 195.9,143.8  197.1,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "139.8,126.9 136.1,126.6 138.7,129.2 136.9,136.5 141.5,130.5 145.1,130.9 142.6,128.2  144.7,120.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.1,86.5l-2.4,0.4l1.4-2c0.2-0.2,0.1-0.5-0.1-0.7c-0.2-0.2-0.5-0.1-0.7,0.1l-1.3,1.9l-0.4-2.3 c0-0.3-0.3-0.5-0.6-0.4c-0.3,0-0.5,0.3-0.4,0.6l0,0l0.4,2.4l-2-1.4c-0.2-0.2-0.5-0.1-0.7,0.1s-0.1,0.5,0.1,0.7l0,0l1.9,1.3 l-2.3,0.4c-0.3,0-0.4,0.3-0.4,0.6s0.3,0.4,0.6,0.4l2.4-0.4l-1.4,2c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1 l1.3-1.9l0.4,2.3c0,0.3,0.3,0.5,0.6,0.4c0.3,0,0.5-0.3,0.4-0.6l0,0l-0.4-2.4l2,1.4c0.2,0.2,0.5,0.1,0.7-0.1 c0.2-0.2,0.1-0.5-0.1-0.7l-1.9-1.3l2.3-0.4c0.3,0,0.5-0.3,0.4-0.6S174.4,86.5,174.1,86.5L174.1,86.5L174.1,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.3,96.2c-0.1-0.7,0.3-1.3,1-1.5c0.7-0.1,1.3,0.3,1.5,1c0.1,0.7-0.3,1.3-1,1.5l0,0 C166.1,97.3,165.4,96.9,165.3,96.2L165.3,96.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M117.1,165.5l98.4-0.4c4.5,0,8.1,3.6,8.2,8.1l0,0l0.3,95.7c0,4.5-3.6,8.1-8.1,8.2l0,0l-98.4,0.4 c-4.5,0-8.1-3.6-8.2-8.1l0,0l-0.3-95.7C108.9,169.2,112.6,165.5,117.1,165.5L117.1,165.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047056663829037938270000009690268924823022218_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.9974,
    y1: 652.0892,
    x2: 130.1009,
    y2: 673.7684,
    gradientTransform: "matrix(1 0 0 1 0 -464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047056663829037938270000009690268924823022218_)"
    },
    points: "118.5,173 128.5,214.6  120.7,226.1 94.5,207.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180351172728333167030000017499134867990756287_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.6787,
    y1: 743.9457,
    x2: 210.1787,
    y2: 743.9457,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000180351172728333167030000017499134867990756287_)"
    },
    points: "122.7,170.5 209.8,170.1  210.2,301.9 123.2,302.2  "
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M128.8,172.7c0.6,0.4,1.2,0.8,1.9,1.1c8.8,4,17.4,4.9,33.7,4.8c19.8-0.1,33.8-1.8,43.1-8.5l-81.8,0.3 L128.8,172.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.7,241l-76.4,0.3c-10.4,0-10,9.8-10,21.9l0,0c0,12.1-0.3,21.8,10.1,21.8l76.4-0.3 c10.4,0,10-9.8,10-21.9l0,0C214.8,250.8,215.1,241,204.7,241z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 281.2,
    transform: "matrix(1 -3.648753e-03 3.648753e-03 1 -1.1017 0.5104)",
    className: "st9",
    width: 32.3,
    height: 42
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.3,
    y: 323.2,
    transform: "matrix(1 -3.651895e-03 3.651895e-03 1 -1.185 0.5113)",
    className: "st10",
    width: 32.3,
    height: 3.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.7,373.3l-32.3,0.1l-2.5-45.4c0-0.9,0.6-1.6,1.5-1.7h0.1l33.5-0.1c0.9,0,1.6,0.7,1.6,1.6 c0,0,0,0,0,0.1L155.7,373.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M115.8,373.5c-0.8,0-1.4-0.5-1.6-1.3c-1-4.4-3.2-18.9,9.2-16.8c14.6,2.4,26.6,18,26.6,18L115.8,373.5z "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 281,
    transform: "matrix(1 -3.647706e-03 3.647706e-03 1 -1.1003 0.7101)",
    className: "st9",
    width: 32.3,
    height: 42
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 178.1,
    y: 323,
    transform: "matrix(1 -3.651720e-03 3.651720e-03 1 -1.1839 0.7114)",
    className: "st10",
    width: 32.3,
    height: 3.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.2,373.2l32.3-0.1l2.2-45.4c0-0.9-0.6-1.6-1.5-1.7h-0.1l-33.5,0.1c-0.9,0-1.6,0.7-1.6,1.6 c0,0,0,0,0,0.1L178.2,373.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M218.2,373.1c0.8,0,1.4-0.5,1.6-1.3c0.9-4.4,3-18.9-9.3-16.8c-14.6,2.5-26.4,18.2-26.4,18.2 L218.2,373.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M209.8,170.1c2.1-0.4,4.6,1.9,5,3.5l-4,42.6l-0.8-0.1L209.8,170.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163773749713633825370000000134386143220684955_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.4274,
    y1: 751.3472,
    x2: 120.589,
    y2: 764.0176,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163773749713633825370000000134386143220684955_)"
    },
    d: "M104.1,257.6l-25.5,19.1l8.5-64.4 c0.3-0.8,1.2-1.2,2.1-0.9c0,0,0,0,0.1,0l29.6,13.3L104.1,257.6z"
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M91,212.4c0.1-2.1,1.8-3.9,3.5-5.2l24.3,17.4L91,212.4z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M122.8,170.5c-2.1-0.4-4.6,1.9-5,3.5l4,42.6l0.8-0.1L122.8,170.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143,199.6l46.6-0.2c2.8,0,5.1,2.3,5.1,5.1l0.1,22.9c0,2.8-2.3,5.1-5.1,5.1l-46.6,0.2 c-2.8,0-5.1-2.3-5.1-5.1l-0.1-22.9C137.9,201.9,140.2,199.6,143,199.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M144.1,201.1l44.6-0.2c2.5,0,4.4,2,4.5,4.4l0.1,21.3c0,2.5-2,4.4-4.4,4.5l-44.6,0.2 c-2.5,0-4.4-2-4.5-4.4l-0.1-21.3C139.6,203.1,141.6,201.1,144.1,201.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M156.9,215.4c0,2.7-2.2,4.9-4.9,5s-4.9-2.2-5-4.9c0-2.7,2.2-4.9,4.9-5 C154.7,210.5,156.9,212.7,156.9,215.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.6,204.9l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.1,205.1,164.4,204.9,164.6,204.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.6,209.9l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,210.1,164.4,209.9,164.6,209.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.7,214.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,215.1,164.4,214.9,164.7,214.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M164.7,219.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,220.1,164.4,219.8,164.7,219.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M164.7,224.8l24-0.1c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5l-24,0.1c-0.3,0-0.5-0.2-0.5-0.5 v-1.5C164.2,225.1,164.4,224.8,164.7,224.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M123.7,214.1L138,214v4.2l-14.3,0.1c-1.1-0.1-2-1-1.9-2.1l0,0C121.8,215.1,122.6,214.1,123.7,214.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M208.9,218.1l-14.1,0.1V214l14.1-0.1c1.1,0.1,1.9,1,1.9,2.1l0,0C210.8,217.1,210,218,208.9,218.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135688015868574770370000012313386567678189708_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.7372,
    y1: 601.704,
    x2: 224.2899,
    y2: 651.059,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#E4EAF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3873,
    style: {
      stopColor: "#CBD7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5777,
    style: {
      stopColor: "#BCCBE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    style: {
      stopColor: "#B7C7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7925,
    style: {
      stopColor: "#BCCBE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#C9D5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9291,
    style: {
      stopColor: "#E0E7F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000135688015868574770370000012313386567678189708_)"
    },
    cx: 166.1,
    cy: 116.3,
    r: 58.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111182480278612563380000003692131348464116402_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.8784,
    y1: 628.1957,
    x2: 222.179,
    y2: 628.1957,
    gradientTransform: "matrix(1 0 0 1 -6.507888e-06 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3724,
    style: {
      stopColor: "#C1D0EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7037,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111182480278612563380000003692131348464116402_)"
    },
    d: "M165.9,74.5 c31-0.1,56.3,20.4,56.3,45.7c0.1,25.4-25,46-56,46.1c-31,0.1-56.2-20.3-56.3-45.7S134.9,74.6,165.9,74.5z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -3.648055e-03 3.648055e-03 1 -0.4381 0.6067)",
    className: "st18",
    cx: 166.1,
    cy: 120.4,
    rx: 54.7,
    ry: 44.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096048943667926939620000004961440540528033193_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.3469,
    y1: 609.7322,
    x2: 146.088,
    y2: 609.7322,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096048943667926939620000004961440540528033193_)"
    },
    d: "M145.8,95.7 c-1.4-4.9-7.3-5.5-13.8-0.1c-6.5,5.4-9.3,10.8-6.5,13.7c3.8,3.9,7.5,4.1,13.5-1.9C142.7,103.5,147.3,100.8,145.8,95.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023981836423456502510000008881617999506135981_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.4099,
    y1: 738.1808,
    x2: 209.3038,
    y2: 756.5208,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023981836423456502510000008881617999506135981_)"
    },
    d: "M236.2,258.6H261l-15.8-52.8 c-0.3-0.8-1.2-1.2-2.1-0.9c0,0,0,0-0.1,0l-31.7,14L236.2,258.6z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M241.3,205.7c-0.1-2.1-1.8-3.9-3.5-5.2l-24.3,17.4L241.3,205.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000905814022995109040000007112367459471112376_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.0611,
    y1: 650.0794,
    x2: 209.489,
    y2: 670.5699,
    gradientTransform: "matrix(1 0 0 1 0 -464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000905814022995109040000007112367459471112376_)"
    },
    points: "214.8,173.6 210.7,214.4  211.5,219.3 237.7,200.5  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "96,188.7 244.6,185.1 243,298 108.6,308.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091718958936770334600000017340153104635626626_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.0587,
    y1: 773.1033,
    x2: 126.6731,
    y2: 795.3795,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091718958936770334600000017340153104635626626_)"
    },
    d: "M97.2,294.2l-14.6-12.7l12-16.6 l1-1.3l3.8-3.4l2.2-1.7c2-0.9,4.2-1.3,6.4-1.2h8.3c2.5,0,4.6,1.8,4.9,4.3c0.2,2.6-1.7,4.9-4.3,5.2c-0.2,0-0.3,0-0.5,0h-1.6 l7,6.1c4.3,3.8,4.8,10.3,1,14.7l-4.5,5.2C113,299,103.5,299.7,97.2,294.2L97.2,294.2z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.6,281.5c-2-0.7-3.3-2.8-4-4.8l22.2-17.6L82.6,281.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "237.8,259.6 261,262 261,258.6 241,258.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111156174790326959810000013563223646477561530_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.1073,
    y1: 783.1641,
    x2: 225.4876,
    y2: 785.9943,
    gradientTransform: "matrix(1 0 0 1 0 -507.7957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B7C7DE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111156174790326959810000013563223646477561530_)"
    },
    d: "M258.9,281.2l2-19.2l-22.5-2.4l0,0 h-0.6l0,0l-14.6,7.9c-0.9,0.5-1.7,1.3-2.3,2.1c-0.8,1.3-1,2,0.2,3.7c0.7,1.3,2.3,1.9,3.8,1.4c0.7-0.2,1.4-0.6,1.9-1.1 l0.5-0.5l-1,9.3c-0.6,5.7,3.5,10.8,9.2,11.4l6.8,0.7C250.6,295.5,258,289.5,258.9,281.2L258.9,281.2z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "181.2,112.4 179.8,112.3 180.8,113.3 180.1,116.2 181.9,113.8 183.4,114 182.4,112.9  183.2,110  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M201.3,128.9c-0.1-0.7,0.3-1.3,1-1.5s1.3,0.3,1.5,1c0.1,0.7-0.3,1.3-1,1.5l0,0 C202.1,130.1,201.4,129.6,201.3,128.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.6,149.7c0.2,0,0.4,0.1,0.4,0.3c0,0.1,0,0.2-0.1,0.3l-2.9,4.2c-0.1,0.2-0.3,0.2-0.5,0.1 c-0.2-0.1-0.2-0.3-0.1-0.5l2.9-4.2C155.4,149.8,155.5,149.8,155.6,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152,150.4c0.1,0,0.2,0,0.3,0.1l4.2,2.9c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1l0,0 l-4.2-2.9c-0.2-0.1-0.2-0.3-0.1-0.5C151.8,150.5,151.9,150.4,152,150.4L152,150.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "194.3,143 192.1,142.8 193.7,144.3 192.6,148.5 195.2,145.1 197.3,145.3 195.9,143.8  197.1,139.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "139.8,126.9 136.1,126.6 138.7,129.2 136.9,136.5 141.5,130.5 145.1,130.9 142.6,128.2  144.7,120.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M174.1,86.5l-2.4,0.4l1.4-2c0.2-0.2,0.1-0.5-0.1-0.7c-0.2-0.2-0.5-0.1-0.7,0.1l-1.3,1.9l-0.4-2.3 c0-0.3-0.3-0.5-0.6-0.4c-0.3,0-0.5,0.3-0.4,0.6l0,0l0.4,2.4l-2-1.4c-0.2-0.2-0.5-0.1-0.7,0.1s-0.1,0.5,0.1,0.7l0,0l1.9,1.3 l-2.3,0.4c-0.3,0-0.4,0.3-0.4,0.6s0.3,0.4,0.6,0.4l2.4-0.4l-1.4,2c-0.2,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.5,0.1,0.7-0.1 l1.3-1.9l0.4,2.3c0,0.3,0.3,0.5,0.6,0.4c0.3,0,0.5-0.3,0.4-0.6l0,0l-0.4-2.4l2,1.4c0.2,0.2,0.5,0.1,0.7-0.1 c0.2-0.2,0.1-0.5-0.1-0.7l-1.9-1.3l2.3-0.4c0.3,0,0.5-0.3,0.4-0.6S174.4,86.5,174.1,86.5L174.1,86.5L174.1,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M165.3,96.2c-0.1-0.7,0.3-1.3,1-1.5c0.7-0.1,1.3,0.3,1.5,1c0.1,0.7-0.3,1.3-1,1.5l0,0 C166.1,97.3,165.4,96.9,165.3,96.2L165.3,96.2z"
  })))))))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "69.5,176 71.4,175.2 69.5,174.6 68.5,170.5 67.8,174.7 65.9,175.4 67.8,176.1 68.7,180.2  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,99c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4l0,0C97,97.6,97.6,98.2,97.6,99L97.6,99z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M266.4,208.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.2,0.1-0.3l4.9-4.9c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7 l-4.9,4.9C266.6,208,266.5,208.1,266.4,208.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M271.3,208.1c-0.1,0-0.2-0.1-0.3-0.1l-5-5c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l4.9,4.9 c0.2,0.2,0.2,0.5,0,0.7C271.5,208,271.4,208.1,271.3,208.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46,82.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.2,0.1-0.3l4.9-4.9c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l0,0l-4.9,4.9C46.2,82.5,46.1,82.6,46,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.9,82.6c-0.1,0-0.2-0.1-0.3-0.1l-4.9-4.9c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l4.9,4.9 c0.2,0.2,0.2,0.5,0,0.7C51.1,82.5,51,82.6,50.9,82.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.2,158.8c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.1-0.1,0.2-0.1l4.5-0.2c0.2,0,0.3,0.1,0.3,0.3 s-0.1,0.3-0.3,0.3l-4.5,0.2C252.4,158.8,252.3,158.8,252.2,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.6,160.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.2-4.5c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3l0.2,4.5 c0,0.2-0.1,0.3-0.3,0.3C254.7,161,254.7,160.9,254.6,160.9L254.6,160.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.7,157c0-0.2,0.1-0.3,0.3-0.3c0.1,0,0.2,0,0.2,0.1l3.4,2.9c0.1,0.1,0.1,0.3,0,0.4 c-0.1,0.1-0.3,0.1-0.4,0l0,0l-3.4-2.9C252.7,157.2,252.7,157.1,252.7,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.9,160.2c0-0.1,0-0.2,0.1-0.2l2.9-3.4c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.1,0.3,0,0.4l0,0l-2.9,3.4 c-0.1,0.1-0.3,0.1-0.4,0C253,160.3,252.9,160.2,252.9,160.2L252.9,160.2z"
  })))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "275.6,132.9 277.7,132.1 275.6,131.4 274.5,127.1 273.8,131.5 271.7,132.2 273.8,133 274.7,137.4  "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.3,156c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4l0,0C87.2,153.5,88.3,154.6,88.3,156z"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127,250.4c0-1.9,0-3.7,0-5.6c0-0.2,0.1-0.4,0.1-0.6c0.3-2.3,0.6-4.5,1.1-6.8c1.7-7.6,5.2-14.3,10.4-20.2 c2.9-3.3,6.2-6.1,9.9-8.4c5.6-3.5,11.7-5.7,18.2-6.6c1.1-0.1,2.2-0.3,3.3-0.4c1.9,0,3.7,0,5.6,0c1.1,0.1,2.2,0.3,3.3,0.4 c5.2,0.6,10,2.2,14.7,4.5c6.6,3.4,12.1,8.1,16.5,14.2c4.4,6.2,7.1,13,8.1,20.6c0.1,1.1,0.3,2.2,0.4,3.2c0,1.9,0,3.7,0,5.6 c0,0.2-0.1,0.4-0.1,0.6c-0.4,2.3-0.6,4.6-1.1,6.9c-0.7,3.7-2.1,7.2-3.8,10.5c-3.4,6.6-8.1,12.1-14.2,16.5c-6.2,4.4-13,7.1-20.5,8.1 c-1.1,0.1-2.2,0.3-3.3,0.4c-1.9,0-3.7,0-5.6,0c-1.1-0.1-2.2-0.3-3.3-0.4c-5.2-0.6-10.1-2.2-14.7-4.6c-6.6-3.4-12.1-8.1-16.4-14.2 c-4.4-6.2-7.1-13-8.1-20.5C127.3,252.6,127.2,251.5,127,250.4z M153.2,275.6c13.9,10,33.8,8.3,45.9-5.9 c10.8-12.8,10.3-30.4,1.7-41.7C184.9,243.8,169,259.7,153.2,275.6z M144.8,267.2c15.9-15.9,31.8-31.8,47.6-47.7 c-12.6-9.3-32.8-9.1-45.7,5.8C136.4,237.3,135.7,254.9,144.8,267.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatesIllustrationAccessDenied);
export default __webpack_public_path__ + "static/media/empty-states_illustration_access_denied.3057bf545b97363d61605deb86301ecf.svg";
export { ForwardRef as ReactComponent };